// Environment Configuration for MaakDream Website
// This file manages environment-specific settings and API configurations

const ENV = process.env.NODE_ENV || 'development';
const base_url = process.env.REACT_APP_BASE_URL;
const config = {
    // Development environment
    development: {
        api: {
            baseURL: base_url,
            apiKey: '_MfqRwvkpTMIDm-DHk9M3UnUpAx2YiFnK2nbGAJOKT0', // Development API key
            timeout: 10000
        },
        email: {
            enabled: true,
            debug: true
        },
        security: {
            rateLimitEnabled: true,
            validationEnabled: true
        }
    },

    // Production environment
    production: {
        api: {
            baseURL: base_url, // Production domain 
            apiKey: '_MfqRwvkpTMIDm-DHk9M3UnUpAx2YiFnK2nbGAJOKT0', // Production API key
            timeout: 15000
        },
        email: {
            enabled: true,
            debug: false
        },
        security: {
            rateLimitEnabled: true,
            validationEnabled: true
        }
    },

    // Test environment
    test: {
        api: {
            baseURL: base_url,
            apiKey: '_MfqRwvkpTMIDm-DHk9M3UnUpAx2YiFnK2nbGAJOKT0',
            timeout: 5000
        },
        email: {
            enabled: false,
            debug: true
        },
        security: {
            rateLimitEnabled: false,
            validationEnabled: true
        }
    }
};

// Get current environment configuration
export const getConfig = () => config[ENV] || config.development;

// API Configuration
export const API_CONFIG = getConfig().api;

// Email Configuration
export const EMAIL_CONFIG = getConfig().email;

// Security Configuration
export const SECURITY_CONFIG = getConfig().security;

// Environment helpers
export const isDevelopment = ENV === 'development';
export const isProduction = ENV === 'production';
export const isTest = ENV === 'test';

// Feature flags
export const FEATURES = {
    EMAIL_SERVER: EMAIL_CONFIG.enabled,
    RATE_LIMITING: SECURITY_CONFIG.rateLimitEnabled,
    FORM_VALIDATION: SECURITY_CONFIG.validationEnabled,
    DEBUG_MODE: EMAIL_CONFIG.debug
};

// Validation rules
export const VALIDATION_RULES = {
    EMAIL: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Please enter a valid email address'
    },
    PHONE: {
        minLength: 10,
        message: 'Please enter a valid phone number'
    },
    NAME: {
        minLength: 2,
        maxLength: 100,
        message: 'Name must be between 2 and 100 characters'
    },
    MESSAGE: {
        maxLength: 1000,
        message: 'Message must be less than 1000 characters'
    }
};

// Rate limiting configuration
export const RATE_LIMIT_CONFIG = {
    PER_MINUTE: 10,
    PER_HOUR: 100,
    PER_DAY: 1000
};

// Form types for API endpoints
export const FORM_TYPES = {
    MEETING_REQUEST: 'meeting',
    CONTACT_FORM: 'contact',
    BROKER_REGISTRATION: 'broker'
};

// API Endpoints
export const API_ENDPOINTS = {
    MEETING_REQUEST: '/api/send-meeting-request',
    CONTACT_FORM: '/api/send-contact-form',
    BROKER_REGISTRATION: '/api/send-broker-registration',
    HEALTH_CHECK: '/health'
};

// Meeting Request Configuration
export const MEETING_CONFIG = {
    TIME_SLOTS: [
        '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM',
        '12:00 PM', '12:30 PM', '01:00 PM', '01:30 PM', '02:00 PM', '02:30 PM',
        '03:00 PM', '03:30 PM', '04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM'
    ],
    PROPERTY_OPTIONS: [
        'Buy a Property',
        'General Inquiry',
        'Investment Consultation'
    ],
    MIN_DATE_OFFSET: 0, // Days from today (0 = today)
    MAX_DATE_OFFSET: 365 // Days from today (365 = 1 year)
};

// Success messages
export const SUCCESS_MESSAGES = {
    [FORM_TYPES.MEETING_REQUEST]: 'Meeting request sent successfully! We will contact you shortly to confirm.',
    [FORM_TYPES.CONTACT_FORM]: 'Message sent successfully! We will get back to you soon.',
    [FORM_TYPES.BROKER_REGISTRATION]: 'Registration submitted successfully! We will contact you shortly.'
};

// Error messages
export const ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network error. Please check your connection and try again.',
    RATE_LIMIT_ERROR: 'Too many requests. Please wait a moment and try again.',
    VALIDATION_ERROR: 'Please check your input and try again.',
    SERVER_ERROR: 'Server error. Please try again later.',
    AUTH_ERROR: 'Authentication error. Please contact support.',
    UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.'
};

export default {
    getConfig,
    API_CONFIG,
    EMAIL_CONFIG,
    SECURITY_CONFIG,
    isDevelopment,
    isProduction,
    isTest,
    FEATURES,
    VALIDATION_RULES,
    RATE_LIMIT_CONFIG,
    FORM_TYPES,
    SUCCESS_MESSAGES,
    ERROR_MESSAGES
}; 